import React from 'react';
import useChatStarterPrompts from '@/hooks/useChatStarterPrompts';
import StarterSuggestions from '@/components/StarterSuggestions';
import { pickWorkSuggestionItems } from '@/constants/work';

import { DEFAULT_SUGGESTIONS } from '@/constants/chatStarterSuggestions';

export default function ChatStarterSuggestions({ onSelect, hasFiles = false, enabled = true }) {
  const { items } = useChatStarterPrompts({ enabled });
  const suggestions = pickWorkSuggestionItems(items, DEFAULT_SUGGESTIONS);
  return (
    <StarterSuggestions
      items={suggestions}
      onSelect={onSelect}
      hasFiles={hasFiles}
      accessibilityLabel={suggestions === DEFAULT_SUGGESTIONS ? 'Chat suggestions' : 'Suggested conversations based on your memory'}
    />
  );
}
